/**
 * Theme preference: persisted in cookie. Values: 'light' | 'dark'.
 * Default when no cookie: 'light'.
 */
const COOKIE_NAME = 'slr_theme';
const COOKIE_MAX_AGE_DAYS = 365;

export function getThemeFromCookie() {
	if (typeof document === 'undefined') return 'light';
	const match = document.cookie.match(new RegExp('(^|\\s)' + COOKIE_NAME + '=([^;]+)'));
	const value = match ? match[2].trim().toLowerCase() : '';
	return value === 'dark' ? 'dark' : 'light';
}

export function setThemeCookie(theme) {
	const value = theme === 'dark' ? 'dark' : 'light';
	document.cookie = COOKIE_NAME + '=' + value + ';path=/;max-age=' + (COOKIE_MAX_AGE_DAYS * 24 * 60 * 60) + ';SameSite=Lax';
}
